import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/autoReplenishEmbedded/show/showSelector';

const showAutoReplenishEmbeddedSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showAutoReplenishEmbeddedSelector };
